import { LayoutHeader } from "@/Header";
import { createFileRoute } from "@tanstack/react-router";
import useOwnerPush from "^/business/user/useOwnerPush";
import { useCallback, useId } from "react";

export const Route = createFileRoute("/business/layout/user-owner-push")({
  component: RouteComponent,
});

function RouteComponent() {
  // const { watch } = useForm<SignUpCustomerState>();
  const { pushInfo, handlePushInfo, isLoading } = useOwnerPush();
  console.log(pushInfo);
  // const [cookie] = useCookies(["email"]);
  // const email: string = useMemo(() => cookie.email, [cookie]);
  // const ownerOptions = [
  //   { value: "owner1", label: "위탁사업자 이름" },
  //   { value: "owner2", label: "위탁사업자 이름2" },
  // ];
  // console.log(watch());
  // const bindSubmit = (data: SignUpCustomerState) => {
  //   console.log(data);
  //   alert("발송");
  //   // history.push("/business/layout/to-school");
  // };
  return (
    <>
      <LayoutHeader title={"알림"} hasBackBtn hasFootPrint={false} />
      {/* 수신자 */}
      <div className="flex-auto flex flex-col bg-[#F5F5F5]">
        {isLoading ? (
          <div className="flex items-center justify-center h-full">
            <div className="text-sm font-bold">로딩중...</div>
          </div>
        ) : (
        <div className="flex flex-col flex-auto gap-4 px-5 pt-5 rounded-t-3xl">
          <div className="text-[16px] font-semibold">계정 설정</div>
          <div className="bg-white border-2 border-[#E9E9E9] rounded-xl">
            {isLoading ? (
              <div className="flex justify-center items-center py-8">
                <div className="text-gray-500">로딩 중...</div>
              </div>
            ) : pushInfo ? (
              <>
                <div className="flex justify-between items-center px-4 py-2 w-full">
                  <span>알림/공지 푸시 알림</span>
                  <ToggleSwitch
                    checked={pushInfo.alarmNoticeYn === "Y"}
                    onChange={(checked) =>
                      handlePushInfo("alarmNoticeYn", checked ? "Y" : "N")
                    }
                    // disabled={isUpdating}
                  />
                </div>
                <div className="flex justify-between items-center px-4 py-2 w-full">
                  <span>마케팅정보 푸시 알림</span>
                  <ToggleSwitch
                    checked={pushInfo.alarmMarketingYn === "Y"}
                    onChange={(checked) =>
                      handlePushInfo("alarmMarketingYn", checked ? "Y" : "N")
                    }
                    // disabled={isUpdating}
                  />
                </div>
                <div className="flex justify-between items-center px-4 py-2 w-full">
                  <span>SMS/알림톡 알림</span>
                  <ToggleSwitch
                    checked={pushInfo.alarmSmsYn === "Y"}
                    onChange={(checked) =>
                      handlePushInfo("alarmSmsYn", checked ? "Y" : "N")
                    }
                    // disabled={isUpdating}
                  />
                </div>
                <div className="flex justify-between items-center px-4 py-3 w-full">
                  <span>이메일 알림</span>
                  <ToggleSwitch
                    checked={pushInfo.alarmEmailYn === "Y"}
                    onChange={(checked) =>
                      handlePushInfo("alarmEmailYn", checked ? "Y" : "N")
                    }
                    // disabled={isUpdating}
                  />
                </div>
              </>
            ) : (
              <div className="flex justify-center items-center py-8">
                <div className="text-gray-500">데이터를 불러올 수 없습니다.</div>
              </div>
            )}
          </div>

          {/* 카카오 알림톡 서비스 — 회사 단위 (크레딧 차감) */}
          {pushInfo && (
            <>
              <div className="text-[16px] font-semibold mt-2">알림톡 서비스</div>
              <div className="bg-white border-2 border-[#E9E9E9] rounded-xl">
                <div className="flex justify-between items-center px-4 py-3 w-full">
                  <div className="flex flex-col">
                    <span>카카오 알림톡 사용</span>
                    <span className="text-[12px] text-[#888]">
                      푸시 메시지가 발송되는 내용이 카카오 알림톡으로 발송됩니다.
                      <br />
                      알림톡 건당 {pushInfo.kakaoAlimUnitPrice ?? 1}
                      크레딧이 차감됩니다.
                      <br />
                      대체 문자 발송 시 문자 1건당{" "}
                      {pushInfo.smsFallbackUnitPrice ?? 2}크레딧이 차감됩니다.
                    </span>
                  </div>
                  <ToggleSwitch
                    checked={pushInfo.kakaoAlimUseYn === "Y"}
                    onChange={(checked) =>
                      handlePushInfo("kakaoAlimUseYn", checked ? "Y" : "N")
                    }
                  />
                </div>
              </div>
              <div className="text-[12px] text-[#888] leading-relaxed">
                알림톡 서비스를 비활성화 하는 경우 모든 알림톡 발송이 중단되며,
                비용이 발생하지 않습니다.
                <br />
                매장에 전송되는 알림톡은 매장 원장님에게만 발송됩니다.
                <br />
                <br />
                매장에서 받는 알림톡 : 예약신청, 이용권 결제
                <br />
                보호자님이 받는 알림톡 : 예약 확정, 예약 취소, 알림장
              </div>
            </>
          )}

          <div className="text-[13px] text-[#666666]">
            알림톡 사용 해제 시 알림은 푸시 메시지만 발송
            </div>
          </div>
        )}
      </div>
    </>
  );
}

const ToggleSwitch = ({
  onChange,
  checked,
  // disabled,
}: {
  onChange: (checked: boolean) => void;
  checked: boolean;
  // disabled: boolean;
}) => {
  const id = useId();

  const handleChange = useCallback(() => {
    onChange(!checked);
  }, [checked, onChange]);

  return (
    <div className="flex items-center">
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={handleChange}
        className="hidden"
        // disabled={disabled}
      />
      <label
        htmlFor={id}
        className={`
          cursor-pointer relative flex items-center
          min-w-[40px] h-3 px-4 rounded-full transition-colors
          ${checked ? "bg-orange-400" : "bg-[#CCCCCC]"}
          border border-gray-300 text-center
        `}
        style={{ minWidth: 50, height: 24 }}
      >
        <span
          className={`
            absolute top-1/2 -translate-y-1/2 w-5 h-5 rounded-full bg-white shadow transition-all duration-200
            ${checked ? "right-2" : "left-2"}
          `}
          style={{
            left: checked ? "auto" : 2,
            right: checked ? 2 : "auto",
          }}
        />
      </label>
    </div>
  );
};
